/**
 * Default timeout for fetch requests in milliseconds. Defaults to 5 seconds.
 * @type {number}
 */
const DefaultTimeout = 5000;

export default DefaultTimeout;
